module.exports = __webpack_public_path__ + "static/assets/40ae5dcb315899ba3a1de199ceaa770d.png";